import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useLocalization from '@/context/localization/useLocalization';

type Props = {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  canonical?: `/${string}`;
};

const Seo = ({ title, description, image, canonical }: Props) => {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const { locale } = useLocalization();
  const isHome = pathname?.replace(locale || '', '') === '/';
  const origin = window.location.origin;

  return (
    <Helmet>
      <title>{isHome ? title : `${title ? `${title} | ` : ''}${t('common:seo.title')}`}</title>

      {title && <meta property='og:title' content={title} />}
      {title && <meta property='title' content={title} />}

      {description && <meta name='description' content={description} />}

      {title && <meta name='twitter:title' content={title} />}

      {image && <meta name='twitter:image' content={image} />}

      {canonical && <link rel='canonical' href={`${origin}${canonical}`} />}
    </Helmet>
  );
};

export default Seo;
